function initCartGreetingUpsell() {
  var section = document.querySelector('[data-cart-greeting]');
  if (!section) return;
  if (section.getAttribute('data-cart-greeting-initialized') === 'true') return;
  section.setAttribute('data-cart-greeting-initialized', 'true');

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  if (root.charAt(root.length - 1) !== '/') root = root + '/';
  var cartAddUrl = root + 'cart/add.js';

  var cards = section.querySelectorAll('[data-card]');
  var modal = section.querySelector('[data-cart-greeting-modal]');
  if (!modal) return;

  var modalCloseEls = modal.querySelectorAll('[data-cart-greeting-close]');
  var textarea = modal.querySelector('[data-cart-greeting-textarea]');
  var countEl = modal.querySelector('[data-cart-greeting-count]');
  var addBtn = modal.querySelector('[data-cart-greeting-add]');
  var errorEl = modal.querySelector('[data-cart-greeting-error]');
  var imgFront = modal.querySelector('[data-modal-image-front]');
  var imgInside = modal.querySelector('[data-modal-image-inside]');
  var isTouchDevice = window.matchMedia('(hover: none)').matches;

  if (!textarea || !countEl || !addBtn || !errorEl || !imgFront || !imgInside) return;

  var activeCard = null;
  var CHAR_LIMIT = 300;

  // Desktop-only hover zoom
  cards.forEach(function (card) {
    var wrap = card.querySelector('[data-card-zoom-trigger]');
    var img = card.querySelector('.js-zoom-image');
    if (!wrap || !img) return;

    // disable zoom on touch devices
    if (isTouchDevice) return;

    var zoomSrc = img.getAttribute('data-zoom-src');
    if (!zoomSrc) return;

    var zoomImg = document.createElement('img');
    zoomImg.src = zoomSrc;
    zoomImg.className = 'zoomImg';
    zoomImg.alt = '';
    zoomImg.setAttribute('aria-hidden', 'true');
    wrap.appendChild(zoomImg);

    var zoomScale = 2;

    wrap.addEventListener('mouseenter', function () {
      var rect = wrap.getBoundingClientRect();
      zoomImg.style.width = rect.width * zoomScale + 'px';
      zoomImg.style.height = rect.height * zoomScale + 'px';
      zoomImg.style.opacity = '1';
    });

    wrap.addEventListener('mouseleave', function () {
      zoomImg.style.opacity = '0';
    });

    wrap.addEventListener('mousemove', function (e) {
      var rect = wrap.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;

      var zoomWidth = zoomImg.offsetWidth;
      var zoomHeight = zoomImg.offsetHeight;
      if (!zoomWidth || !zoomHeight) return;

      var maxMoveX = zoomWidth - rect.width;
      var maxMoveY = zoomHeight - rect.height;

      var moveX = (x / rect.width) * maxMoveX;
      var moveY = (y / rect.height) * maxMoveY;

      zoomImg.style.left = -moveX + 'px';
      zoomImg.style.top = -moveY + 'px';
    });
  });

  cards.forEach(function (card) {
    var customizeBtn = card.querySelector('[data-card-customize]');
    if (!customizeBtn) return;

    customizeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openModal(card);
    });
  });

  function openModal(card) {
    cards.forEach(function (c) { c.classList.remove('is-active'); });
    card.classList.add('is-active');

    activeCard = card;
    errorEl.style.display = 'none';
    errorEl.textContent = '';
    textarea.classList.remove('empty-message');

    var label = card.getAttribute('data-card-label') || '';
    var image1 = card.getAttribute('data-image-1') || '';
    var image2 = card.getAttribute('data-image-2') || image1;
    var image3 = card.getAttribute('data-image-3') || image1;
    var priceLabel = card.getAttribute('data-price-label') || '';

    imgFront.classList.add('is-fading');
    imgInside.classList.add('is-fading');

    setTimeout(function () {
      imgFront.src = image2;
      imgInside.src = image3;

      imgFront.alt = label;
      imgInside.alt = label;

      imgFront.onload = function () {
        imgFront.classList.remove('is-fading');
      };
      imgInside.onload = function () {
        imgInside.classList.remove('is-fading');
      };
    }, 150);

    addBtn.textContent = 'Add Card to Cart' + (priceLabel ? ' (' + priceLabel + ')' : '');

    textarea.value = '';
    updateCharCount();

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    textarea.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activeCard = null;
    cards.forEach(function (c) { c.classList.remove('is-active'); });

    imgFront.classList.add('is-fading');
    imgInside.classList.add('is-fading');

    setTimeout(function () {
      imgFront.src = '';
      imgInside.src = '';
      imgFront.classList.remove('is-fading');
      imgInside.classList.remove('is-fading');
    }, 200);
  }

  modalCloseEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  function updateCharCount() {
    var used = textarea.value.length;
    if (used > CHAR_LIMIT) {
      textarea.value = textarea.value.slice(0, CHAR_LIMIT);
      used = CHAR_LIMIT;
    }
    countEl.textContent = CHAR_LIMIT - used;
  }

  textarea.addEventListener('input', updateCharCount);

  addBtn.addEventListener('click', function () {
    if (!activeCard) return;

    var message = textarea.value.trim();
    if (!message) {
      errorEl.textContent = 'Please enter your message.';
      errorEl.style.display = 'block';
      textarea.classList.add('empty-message');
      return;
    }

    var variantId = activeCard.getAttribute('data-variant-id');
    if (!variantId) {
      errorEl.textContent = 'Unable to add this card. Please try again later.';
      errorEl.style.display = 'block';
      return;
    }

    addBtn.disabled = true;
    errorEl.style.display = 'none';
    textarea.classList.remove('empty-message');

    var timestamp = new Date().toISOString();

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: {
          'Message': message,
          '__Greeting timestamp': timestamp
        }
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Network error');
        return res.json();
      })
      .then(function () {
        closeModal();
        window.location.reload();
      })
      .catch(function () {
        errorEl.textContent = 'Something went wrong while adding the card. Please try again.';
        errorEl.style.display = 'block';
      })
      .finally(function () {
        addBtn.disabled = false;
      });
  });
}

function makeUpsellProductsNonClickable() {
  // Check if greeting cards are available by checking the greeting-cards collection
  var isCardUpsellAvailable = false;
  
  // Read product IDs from cart-card-upsell section (from greeting-cards collection)
  var upsellProductsScript = document.querySelector('[data-cart-upsell-products]');
  var upsellProductIds = [];
  
  if (upsellProductsScript) {
    try {
      upsellProductIds = JSON.parse(upsellProductsScript.textContent);
      // If we have product IDs, greeting cards are available
      if (upsellProductIds && upsellProductIds.length > 0) {
        isCardUpsellAvailable = true;
      }
    } catch (e) {
      console.error('Error parsing upsell product IDs:', e);
    }
  }

  // Check if any cart items have display_card_upsells metafield set to true
  var hasDisplayCardUpsells = false;
  var cartItems = document.querySelectorAll('[data-cart-item][data-display-card-upsells]');
  cartItems.forEach(function(item) {
    var displayCardUpsells = item.getAttribute('data-display-card-upsells');
    if (displayCardUpsells === 'true') {
      hasDisplayCardUpsells = true;
    }
  });

  // Handle gift message visibility based on whether card upsell is available AND products have metafield
  // Hide gift message if greeting cards ARE available AND at least one product has display_card_upsells = true
  // Show gift message if greeting cards are NOT available OR no products have display_card_upsells = true
  var noteField = document.querySelector('#note');
  var noteLabel = document.querySelector('label[for="note"]');
  var noteCounter = document.querySelector('.gift-message-counter');
  
  if (isCardUpsellAvailable && hasDisplayCardUpsells) {
    // Hide gift message if card upsell (greeting cards) are available AND products have metafield
    if (noteField) {
      noteField.style.display = 'none';
      if (noteLabel) {
        noteLabel.style.display = 'none';
      }
      if (noteCounter) {
        noteCounter.style.display = 'none';
      }
    }
  } else {
    // Show gift message if card upsell (greeting cards) are NOT available OR no products have metafield
    if (noteField) {
      noteField.style.removeProperty('display');
      if (noteLabel) {
        noteLabel.style.removeProperty('display');
      }
      if (noteCounter) {
        noteCounter.style.removeProperty('display');
      }
    }
  }
  
  // Also check after delay in case counter is created after this runs
  setTimeout(function() {
    var delayedNoteField = document.querySelector('#note');
    var delayedNoteCounter = document.querySelector('.gift-message-counter');
    var delayedNoteLabel = document.querySelector('label[for="note"]');
    
    // Re-check cart items for metafield in case cart was updated
    var delayedHasDisplayCardUpsells = false;
    var delayedCartItems = document.querySelectorAll('[data-cart-item][data-display-card-upsells]');
    delayedCartItems.forEach(function(item) {
      var displayCardUpsells = item.getAttribute('data-display-card-upsells');
      if (displayCardUpsells === 'true') {
        delayedHasDisplayCardUpsells = true;
      }
    });
    
    if (delayedNoteField) {
      if (isCardUpsellAvailable && delayedHasDisplayCardUpsells) {
        // Hide if card upsell (greeting cards) are available AND products have metafield
        delayedNoteField.style.display = 'none';
        if (delayedNoteCounter) {
          delayedNoteCounter.style.display = 'none';
        }
        if (delayedNoteLabel) {
          delayedNoteLabel.style.display = 'none';
        }
      } else {
        // Show if card upsell (greeting cards) are NOT available OR no products have metafield
        delayedNoteField.style.removeProperty('display');
        if (delayedNoteCounter) {
          delayedNoteCounter.style.removeProperty('display');
        }
        if (delayedNoteLabel) {
          delayedNoteLabel.style.removeProperty('display');
        }
      }
    }
  }, 300);

  // Find all cart items and check if they match upsell products from collection
  var cartItems = document.querySelectorAll('[data-cart-item][data-product-id]');
  var hasUpsellProductInCart = false;
  
  cartItems.forEach(function(item) {
    var productId = parseInt(item.getAttribute('data-product-id'));
    
    // Check if product ID is in upsell list (from greeting-cards collection)
    if (upsellProductIds && upsellProductIds.length > 0 && upsellProductIds.indexOf(productId) !== -1) {
      hasUpsellProductInCart = true;
      
      // This is an upsell product - make it non-clickable
      var links = item.querySelectorAll('.cart__item--link');
      links.forEach(function(link) {
        // Remove href and prevent click
        link.removeAttribute('href');
        link.style.cursor = 'default';
        link.addEventListener('click', function(e) {
          e.preventDefault();
          return false;
        });
      });

      // Hide quantity controls if they exist
      var quantityBox = item.querySelector('[data-quantity-controls]');
      if (quantityBox) {
        quantityBox.style.display = 'none';
      }
    }
  });

}

(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initCartGreetingUpsell();
      makeUpsellProductsNonClickable();
    });
  } else {
    initCartGreetingUpsell();
    makeUpsellProductsNonClickable();
  }

  document.addEventListener('cart:refreshed', function() {
    initCartGreetingUpsell();
    makeUpsellProductsNonClickable();
    // Ensure counter is hidden after cart refresh
    setTimeout(function() {
      if (typeof hideCounterIfNoteHidden === 'function') {
        hideCounterIfNoteHidden();
      }
      // Also directly check and hide counter
      var noteCounter = document.querySelector('.gift-message-counter');
      var noteField = document.querySelector('#note');
      if (noteCounter && noteField && (noteField.style.display === 'none' || noteField.offsetParent === null)) {
        noteCounter.style.display = 'none';
      }
    }, 200);
  });
})();
